

































































import Component, {mixins} from 'vue-class-component'
import Vue from 'vue'
import UserRegistrationChart, {IntervalOptions} from '@/modules/user/components/UserRegistrationChart';
import WidgetMixin from '@/modules/widget/mixins/WidgetMixin';

@Component({
    components: {UserRegistrationChart},
})
export default class UserRegistrationStatsWidget extends mixins(WidgetMixin) {
    public $refs: Vue['$refs'] & {
        dp: {
          activePicker: string,
        },
    }
    public intervals = [
        { key: IntervalOptions.Monthly, text: 'Mensual'},
        { key: IntervalOptions.Daily, text: 'Diario'},
        { key: IntervalOptions.Annual, text: 'Anual'},
    ]

    public displayGrid = false
    public loading = false

    public interval: {key: IntervalOptions, text: string} = this.intervals[2]

    public mounted () {
        // this.$refs.dp.activePicker = 'YEAR'
    }
}
